import React from 'react';
import { useAuthContext } from 'contexts/AuthProvider';
import { ApolloProvider } from '@apollo/react-hooks';
import { CognitoUserSession } from 'amazon-cognito-identity-js';

import { createAuthLink, AuthOptions } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { ApolloClient, InMemoryCache } from 'apollo-boost';
import { ApolloLink } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';

const withApollo = (InputComponent: React.FC) => {
  const EnhancedComponent: React.FC = () => {
    const { loading, authUser } = useAuthContext();

    if (loading) return null;

    const url = process.env.REACT_APP_GRAPHQL_ENDPOINT ?? '';
    const region = process.env.REACT_APP_GRAPHQL_REGION ?? '';
    const auth: AuthOptions = {
      type: 'AMAZON_COGNITO_USER_POOLS',
      jwtToken: async () =>
        authUser?.getSession((err: any, session: CognitoUserSession) =>
          session?.getIdToken().getJwtToken()
        ) ?? ''
      // complexObjectsCredentials: () => auth
    };

    const httpLink = createHttpLink({ uri: url });

    const link = ApolloLink.from([
      createAuthLink({
        url,
        region,
        auth
      }),
      createSubscriptionHandshakeLink(url, httpLink)
    ]);

    const client = new ApolloClient({
      link,
      cache: new InMemoryCache()
    });

    return (
      <ApolloProvider client={client}>
        <InputComponent />
      </ApolloProvider>
    );
  };

  return EnhancedComponent;
};

export default withApollo;
